import React from 'react';
import { Helmet } from 'react-helmet';
import LettersGrid from './LettersGrid';
import { Redirect } from 'react-router-dom';

class About extends React.Component {
    constructor(props) {
        super(props);
    }

	render() {
        if(window.innerWidth < 1024) {
            return <Redirect to="/"/>
        }

		return (
            <div className="container">
                <Helmet>
                    <title>La Roulotte Retouche - About</title>
                    <body class="about" />
                </Helmet>

                <LettersGrid />

                <div className="about-content">
                    <div className="col">
                        <p>
                            Je suis un cocktail explosif d’authencitié, de propositions, 
                            de réflexion en amont du shooting, d’accompagnement, d’optimisation des fichiers de travail, d’ancipation des demandes clients. J’accorde beaucoup d’importance au dialogue et à la coordination.
                        </p>
                        <p>
                            Curieuse, j’aime le travail en équipe et apprécie passer un bon moment avec vous, mes clients. Travailleuse indépendante, 
                            je demeure l’unique contact tant dans la partie retouche que commerciale.
                        </p>
                        
                        Je travaille pour :
                        <ul className="no-style">
                            <li>- la publicité</li>
                            <li>- l’éditorial</li>
                            <li>- les contenus de réseaux sociaux </li>
                            <li>- les projets artistiques</li>
                        </ul>
                    </div>
                    <div className="col barlow-it">
                        <p>
                            I am an explosive cocktail of authenticity, ideas, thought 
                            in advance of the photo shoot, care and support, optimization 
                            of the work files, anticipation of the customer’s inquiries. 
                            I attach considerable importance to communication 
                            and coordination.
                        </p>
                        <p>
                            Curious, I love working in a team and appreciate very much spending a good time with you, my clients. As an independant worker, I remain the only contact for both the retouching 
                            and commercial parts. 
                        </p>

                        I work for:
                        <ul className="no-style">
                            <li>- advertising</li>
                            <li>- editorial</li>
                            <li>- social media contents </li>
                            <li>- artistic projects</li>
                        </ul>
                    </div>
                </div>
            </div>
		);
	}
};

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js